import {Component, OnInit} from '@angular/core';
import {BannerBase} from '../banner-base';
import {DialogService} from '../../../../core/services/dialog.service';
import {Ga4EventsConfigService} from '../../../../core/services/ga4-events-config.service';
import {Ga4OffersElementKey} from '../../../../core/consts/ga4-offers-element-key.enum';

@Component({
  selector: 'app-driver-sos-banner',
  templateUrl: './driver-sos-banner.component.html',
  styleUrls: ['./driver-sos-banner.component.scss']
})
export class DriverSosBannerComponent extends BannerBase implements OnInit {

  get imageSrc(): string {
    return './assets/images/banners/driver-sos.svg';
  }

  constructor(public dialogService: DialogService,
              private ga4EventsService: Ga4EventsConfigService) {
    super(dialogService);
  }

  ngOnInit() {
  }

  openPopup() {
    super.openPopup();
    this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.DRIVER_SOS_BANNER);
  }

}
